<template>  
  <div class="row mx-0 justify-content-center">
    <div class="col-md-6 col-xl-3 mb-4 mb-xl-0">
        <div class="card">
          <div class="card-body">
            <div id="teamFirst" class="image"></div>
          </div>
          <div class="card-footer">
              <p><b>Elena Fuentes</b></p>
              <p>Holandesa viviendo en Nicaragua, trabaja como programadora y le encanta compartir conocimiento</p>
          </div>
        </div>
    </div>
    <div class="col-md-6 col-xl-3 mb-4 mb-xl-0">
        <div class="card">
          <div class="card-body">
            <div id="teamSecond" class="image"></div>
          </div>
          <div class="card-footer">
              <p><b>Mayra Amador</b></p>
              <p>Nicaragüense viviendo en Madrid, se dedica a la programación como desarrolladora Front End. </p>
          </div>
        </div>
    </div>
    <div class="col-md-6 col-xl-3">
        <div class="card">
          <div class="card-body">
              <div id="teamThird" class="image"></div>
          </div>
          <div class="card-footer">
              <p><b>Suzy Fuentes (aka: Profe Suzy)</b></p>
              <p>Holandesa viviendo en Holanda, estudia Ciencias Biomédicas en la Universidad de Maastricht.</p>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
  export default {
    name:"Team",
  }
</script>
